export enum AuthType {
  EMAIL_PASSWORD = 'EMAIL_PASSWORD',
  SSO_MICROSOFT = 'SSO_MICROSOFT',
  SSO_GOOGLE = 'SSO_GOOGLE'
}